var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"r-forum-table"},[_c('div',{staticClass:"category"},[_vm._t("title")],2),_c('table',{staticClass:"table-auto forum-table p-5"},[_c('thead',[_vm._t("head")],2),_c('tbody',[_vm._t("body")],2)]),(_vm.$slots.contents)?_c('div',{staticClass:"extra"},[_vm._t("contents")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }